import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=463fd55c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=463fd55c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463fd55c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463fd55c')) {
      api.createRecord('463fd55c', component.options)
    } else {
      api.reload('463fd55c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=463fd55c&scoped=true", function () {
      api.rerender('463fd55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/pei-information/Main.vue"
export default component.exports